<template>
  <div>
    <!-- <v-data-table
    :headers="headers"
    :items="desserts"
    class="elevation-1 mt-4"
    style="background-color:#424242;padding:0 10px; border-radius:10px 10px 0 0 ;"
    hide-actions
    dark
  >
    </v-data-table>-->
    <v-layout wrap align-center class="mt-3">
      <v-flex xs5 sm2 md1 class="mr-1">
        <v-select
          :items="filter_order_type_list"
          item-value="value"
          item-text="name"
          v-model="filter_column"
          @change="filterBy()"
          label="Filter by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs5 sm4 md3>
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'no_default'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'no_default'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="sale_store_list"
      class="elevation-1 mt-4"
      style="background-color:white;padding:10px; border-radius:10px;"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color:black;"
      >{{ props.header.text }}</template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.no }}</td>
        <td>{{ props.item.order_code }}</td>
        <td>{{ props.item.order_base_code }}</td>
        <td>{{ props.item.order_customer_full_name }}</td>
        <td>{{ props.item.order_rider_full_name }}</td>
        <td>{{ props.item.store_name }}</td>
        <td
          class="text-xs-right"
        >{{ typeof props.item.item_price == 'number' ? (parseFloat(props.item.item_price).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '' }}</td>
        <td
          class="text-xs-right"
        >{{ typeof props.item.transport == 'number' ? (parseFloat(props.item.transport).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '' }}</td>
        <td
          class="text-xs-right"
        >{{ typeof props.item.extra_store == 'number' ? (parseFloat(props.item.extra_store).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''}}</td>
        <td
          class="text-xs-right"
        >{{ typeof props.item.promotion == 'number' ? '- ' + (parseFloat(props.item.promotion).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '' }}</td>
        <td
          class="text-xs-right"
        >{{ typeof props.item.order_com == 'number' ? (parseFloat(props.item.order_com).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '' }}</td>
        <td
          class="text-xs-right"
        >{{ typeof props.item.summary == 'number' ? (parseFloat(props.item.summary).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '' }}</td>
        <td>{{ props.item.remark }}</td>
      </template>
      <template slot="footer">
        <td colspan="6" class="text-xs-center">
          <strong>Total</strong>
        </td>
        <td
          class="text-xs-right"
        >{{ sale_store_summary.item_price ? (parseFloat(sale_store_summary.item_price).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
        <td
          class="text-xs-right"
        >{{ sale_store_summary.transport ? (parseFloat(sale_store_summary.transport).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
        <td
          class="text-xs-right"
        >{{ sale_store_summary.extra_store ? (parseFloat(sale_store_summary.extra_store).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
        <td
          class="text-xs-right"
        >-{{ sale_store_summary.promotion ? (parseFloat(sale_store_summary.promotion).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
        <td
          class="text-xs-right"
        >{{ sale_store_summary.com ? (parseFloat(sale_store_summary.com).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
        <td
          class="text-xs-right"
        >{{ sale_store_summary.summary ? (parseFloat(sale_store_summary.summary).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
        <td></td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      filter_order_type_list: [
        {
          name: "Food",
          value: 1
        },
        {
          name: "Free",
          value: 3
        }
      ],
      filter_column: undefined,
      column_items: [{ text: "Revenue", value: "summary", sortable: false }],
      asc_desc: "asc",
      sort_column: "no_default",
      isSort: false,
      count_order: 1,
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "name"
        },
        { text: "Order code", value: "id", sortable: false },
        { text: "Order ref.", value: "id", sortable: false },
        { text: "Customer name", value: "store_name", sortable: false },
        { text: "Rider name", value: "store_name", sortable: false },
        { text: "Store name", value: "store_name", sortable: false },
        {
          text: "Item price",
          value: "item_price",
          sortable: false,
          align: "center"
        },
        {
          text: "Transport",
          value: "transport",
          sortable: false,
          align: "center"
        },
        {
          text: "Extra store",
          value: "extra_store",
          sortable: false,
          align: "center"
        },
        {
          text: "Promotion",
          value: "promotion",
          sortable: false,
          align: "center"
        },
        {
          text: "Com Omise 4%",
          value: "com",
          sortable: false,
          align: "center"
        },
        { text: "Revenue", value: "revenue", sortable: false, align: "center" },
        { text: "Remark", value: "remark", sortable: false, align: "center" }
      ]
    };
  },
  watch: {
    clone_sale_store_list: {
      handler: function() {
        if (this.isSort == false) {
          this.asc_desc = "asc";
          this.sort_column = "no_default";
        }
      },
      deep: true
    }
  },
  methods: {
    async filterBy() {
      await this.$store.commit("fetchSaleStoreReport/resetStoreList");
      if (this.filter_column != undefined) {
        const send_json_data = {
          data: this.sale_store_list,
          filter_value: this.filter_column
        };
        await this.$store.dispatch(
          "fetchSaleStoreReport/filterDataReport",
          send_json_data
        );
      }
      await this.$store.commit("fetchSaleStoreReport/calSaleStoreSummary");
      this.sortBy();
    },
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "no_default";
        this.asc_desc = "asc";
      }
      this.isSort = true;
      const send_json_data = {
        data: this.sale_store_list,
        field: this.sort_column,
        asc_desc: this.asc_desc
      };
      await this.$store.dispatch("sortData", send_json_data);

      await this.$store.commit("fetchSaleStoreReport/getExportFormSaleStore");
      this.$store.commit("fetchSaleStoreReport/getExportSaleStoreSummary");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    }
  },
  computed: {
    ...mapState({
      sale_store_list: state => state.fetchSaleStoreReport.sale_store_list,
      clone_sale_store_list: state =>
        state.fetchSaleStoreReport.clone_sale_store_list,
      sale_store_summary: state =>
        state.fetchSaleStoreReport.sale_store_summary,
      export_form_sale_store: state =>
        state.fetchSaleStoreReport.export_form_sale_store
    })
  }
};
</script>
<style scoped>
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
</style>